import i from 'react';
import { BaseModal } from '@crossbell/ui';

var t="75fc62ecbee313a9c66b2c18f4c73e7c41494426779eb8014542988c6cc575d5",a=`._modal_5dy7w_1 {
	margin-top: auto;
	width: 100%;
	color: rgb(var(--csb-ck-color-text));
	background: rgb(var(--csb-ck-color-bg));
	border-top-left-radius: 28px;
	border-top-right-radius: 28px;
}

._modal_5dy7w_1 * {
	box-sizing: border-box;
}

@media (min-width: 768px) {
	._modal_5dy7w_1 {
		margin-bottom: auto;
		width: auto;
		border-bottom-left-radius: 28px;
		border-bottom-right-radius: 28px;
	}
}

._inner_5dy7w_23 {
	padding: 0;
}
`;(function(){if(!(typeof document>"u")&&!document.getElementById(t)){var o=document.createElement("style");o.id=t,o.textContent=a,document.head.appendChild(o);}})();var d={modal:"_modal_5dy7w_1",inner:"_inner_5dy7w_23"};function p({isActive:o,children:r,onClose:e}){return i.createElement(BaseModal,{className:d.modal,isActive:o,onClickBg:e,onClose:e},r)}

export { p as a };
//# sourceMappingURL=out.js.map
//# sourceMappingURL=chunk-742R2ACG.mjs.map